<template>
  <v-app v-bind="$refs.Layout ? $refs.Layout.theme : {}">
    <component :is="layout" ref="Layout" id="LayoutWrapper" />
    <v-dialog
      v-if="sessionExpired"
      v-model="sessionExpired"
      persistent
      max-width="600px"
    >
      <SessionReset />
    </v-dialog>
    <portal-target name="modal-container" />
  </v-app>
</template>

<script>
import '@assets/scss/app.scss';
import PortalVue from 'portal-vue';
import Vue from 'vue';
Vue.use(PortalVue);

const ComponentContext = require.context('./layouts', true, /\.vue$/i);
const layouts = {};
ComponentContext.keys().forEach((componentFilePath) => {
  const component = componentFilePath
    .split('/')
    .pop()
    .split('.')[0];
  layouts[component] = () => import(`@layouts/${component}`);
});
export default {
  name: 'App',
  components: {
    SessionReset: () => import('@components/auth/SessionReset'),
    ...layouts,
  },
  data() {
    return {
      sessionExpired: false,
    };
  },
  computed: {
    layout() {
      return this.$route.meta.layout || 'Default';
    },
  },
  mounted() {
    let self = this;
    $bus.$on('offline', () => {
      this.$router.push({ name: 'offline-trips' });
    });

    if (!navigator) {
      return;
    }

    if (navigator.onLine === false) {
      this.$router.push({ name: 'offline-trips' });
      return;
    }

    if (navigator.onLine) {
      $bus.$on('session-expired', () => {
        self.sessionExpired = true;
      });
      $bus.$on('session-refreshed', () => {
        self.sessionExpired = false;
      });
    }
  },
};
</script>

<style lang="scss">
.cursor-pointer {
  cursor: pointer;
}
</style>
